import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import { Grid } from "@mantine/core";
import { Control, Controller } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import Select from "@/components/atoms/Select";
import NumberInput from "@/components/atoms/NumberInput";

interface PaymentPreferencesProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const PaymentPreferences: React.FC<PaymentPreferencesProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading" mt={20}>
        {t("registerCompany:paymentPreferences.title")}
      </Text>
      <Grid>
        {/*<Grid.Col span={1} pr={0} mr={0}>*/}
        {/*  <SVGAsset name="circle-questionmark" />*/}
        {/*</Grid.Col>*/}
        {/*<Grid.Col span={10} pl={0} ml={0}>*/}
        {/*  <Text size="sm" color="secondary">*/}
        {/*    {t("registerCompany:bankAccount.reason")}*/}
        {/*  </Text>*/}
        {/*</Grid.Col>*/}
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={12}>
        <Controller
          name="partialCompany.creditLimit"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <NumberInput
              data-testid="credit-limit-input"
              label={t("registerCompany:paymentPreferences.creditLimit")}
              value={value ?? 0}
              onChange={onChange}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.invoiceDaysBeforeDueDate"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <Select
              data-testid="invoice-days-before-due-date-select"
              label={t("registerCompany:paymentPreferences.invoiceDaysBeforeDueDate")}
              value={value !== undefined && value !== null ? String(value) : ""}
              required
              data={[
                { value: "14", label: "14 " + t("common:days") },
                { value: "30", label: "30 " + t("common:days") },
                { value: "60", label: "60 " + t("common:days") },
              ]}
              onChange={(val) => onChange(val ? Number(val) : undefined)}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.settlementDays"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <Select
              data-testid="settlement-days-select"
              label={t("registerCompany:paymentPreferences.settlementDays")}
              value={value !== undefined && value !== null ? String(value) : ""}
              required
              data={[
                { value: "14", label: "14 " + t("common:days") },
                { value: "30", label: "30 " + t("common:days") },
                { value: "60", label: "60 " + t("common:days") },
              ]}
              onChange={(val) => onChange(val ? Number(val) : undefined)}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default PaymentPreferences;
